import {NotificationMessage} from "./NotificationMessage";
import {useNavigate} from "react-router-dom";
import React from "react";

export const CommentReplyNotification = ({ notification }) => {
    const comment = notification.entities.find((dataEntity) => dataEntity.type === 'comment').data;
    const message = notification.message;
    const linkTo = '/comments/' + comment.id;
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(linkTo);
    };

    return (
        <div style={{display: "flex", flexDirection: "column", cursor: "pointer"}} onClick={handleNavigate}>
            <NotificationMessage
                message={comment?.body}
                linkTo={linkTo}
                trimText={true}
            />
            <div className="notification__masterclass-comment__comment-text">
                {message}
            </div>
        </div>
    );
};